import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { serverContext } from '../App';
import axios from 'axios';

const MissionSelect = props => {
    const { server } = useContext(serverContext);
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;
   
    const [selectedMission] = useState(props.mission ? {
        id: props.mission.id,
        name: props.mission.name
    } : undefined);


    useEffect(() => {
        let active = true;

         if (!loading) {
             return undefined;
         }

        (async () => {
            try {
                const res = await axios(
                    `${server.serverHost}/api/missions/brief`, {
                    headers: { 'Authorization': `Basic ${server.token}` }
                });

                if (active) {
                    setOptions(res.data);
                }
            } catch (error) {
                console.log(error.message);
            }    

        })();

        return () => {
            active = false;
        };
    }, [loading, server.serverHost, server.token]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    return (
        <Autocomplete
            size="small"
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option.name === value.name}
            getOptionLabel={(option) => option.name}
            options={options}
            loading={loading}
            value={selectedMission}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard" label="Mission"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
            onChange={(event, value, reason) => props.onChange(value, reason)}
        />
    );
}

export default MissionSelect;